import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import Drawer from '../../../../components/AppDrawer';
import CustomerSegmentForm, { type CustomerSegmentFormFieldValues } from './CustomerSegmentForm';
import type { CustomerSegmentDetail, CustomerSegmentFormValues } from '../types';

export interface CustomerSegmentFormDrawerProps {
  open: boolean;
  onClose: () => void;
  mode: 'add' | 'edit';
  customerSegment: CustomerSegmentDetail | null | undefined;
  loadingCustomerSegment: boolean;
  onSave: (values: CustomerSegmentFormValues) => void;
  saving: boolean;
}

const CustomerSegmentFormDrawer: React.FC<CustomerSegmentFormDrawerProps> = ({
  open,
  onClose,
  mode,
  customerSegment,
  loadingCustomerSegment,
  onSave,
  saving,
}) => {
  const [form] = Form.useForm<CustomerSegmentFormFieldValues>();

  useEffect(() => {
    if (!open) return;
    if (mode === 'add') {
      form.resetFields();
      form.setFieldsValue({ isActive: true });
    }
  }, [open, mode, form]);

  const title = mode === 'add' ? 'Add customer segment' : 'Edit customer segment';

  return (
    <Drawer
      title={title}
      destroyOnClose
      size="large"
      placement="right"
      open={open}
      onClose={onClose}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" loading={saving} onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      }
    >
      {(mode === 'add' || !loadingCustomerSegment) && (
        <CustomerSegmentForm
          form={form}
          initialValues={mode === 'edit' ? customerSegment ?? null : null}
          onFinish={onSave}
        />
      )}
    </Drawer>
  );
};

export default CustomerSegmentFormDrawer;
